import React from 'react';
import {Platform, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../theme';
import Text from '../../components/elements/Text';
import Header from '../../components/elements/Header';
import {Linking} from 'react-native';
import Button from '../../components/elements/Button';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';

const ContactSupport = ({navigation, route}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <SafeAreaView
      testID={tID('ContactSupport-SafeAreaView-Main')}
      style={[styles.mainView, Platform.OS === 'web' && styles.webContainer]}>
      <View
        testID={tID('ContactSupport-View-HeaderContainer')}
        style={CommonStyles.p_24}>
        <Header
          testID={tID('ContactSupport-Header-ContactSupport')}
          title="Contact Support"
          onPressLeftIcon={() => {
            navigation.goBack();
            route?.params?.onRequestOpen && route?.params?.onRequestOpen();
          }}
          hideLeftIem={Platform.OS === 'web'}
        />
        <Text
          testID={tID('ContactSupport-Text-AtDiathrive')}
          variation="Subtitle2Regular"
          color={colors.textMuted}
          topMargin={24}>
          At Diathrive we find it important that you get the support you need,
          whenever you need it.
        </Text>
        {Platform.OS === 'web' ? (
          <Text
            testID={tID('ContactSupport-Text-ReachOut')}
            variation="Subtitle2Regular"
            color={colors.textMuted}
            topMargin={24}>
            You may reach out to support via email or phone. Please tap on one
            of the following contact options to reach out to a Diathrive
            Administrator. We will do our best to respond to you in a timely
            manner.
          </Text>
        ) : (
          <Text
            testID={tID('ContactSupport-Text-ReachOut')}
            variation="Subtitle2Regular"
            color={colors.textMuted}
            topMargin={24}>
            You may reach out to support via email, phone or through chat.
            Please tap on one of the following contact options to reach out to a
            Diathrive Administrator. We will do our best to respond to you in a
            timely manner.
          </Text>
        )}

        <Text
          testID={tID('ContactSupport-Text-ContactOptions')}
          variation="Body1SemiBold"
          color={colors.textPrimary}
          topMargin={32}>
          Contact Options
        </Text>
        <View style={CommonStyles.mt_16}>
          <Button
            title={'Email Support'}
            onPress={() => Linking.openURL('mailto:support@diathrive.com')}
          />
        </View>
        <View style={CommonStyles.mt_16}>
          <Button
            title={'Call Support'}
            onPress={() => Linking.openURL('tel:+18668787477')}
          />
        </View>
      </View>
    </SafeAreaView>
  );
};

export default ContactSupport;
